/* eslint camelcase: 0 */
/* eslint no-underscore-dangle: 0 */

// Doble encomillado a propósito, como el fork legacy: "hola" sale "'hola'". Los
// consumidores de texto (microbit_compare_strings, microbit_bluetooth_send,
// microbit_matrix8x8_text) sacan la comilla simple para desarmarlo; con una sola comilla
// esos tres se rompen.
export const text = (block, generator) => {
  const code = `"${generator.quote_(block.getFieldValue('TEXT'))}"`;

  return [code, generator.ORDER_ATOMIC];
};

// Cada término se re-encomilla en doble tras sacarle sus comillas, como en el legacy; un
// número enchufado acá termina concatenado como texto, igual que en prod.
export const text_unir = (block, generator) => {
  if (block.itemCount_ === 0) {
    return ["''", generator.ORDER_ATOMIC];
  }

  if (block.itemCount_ === 1) {
    const item = generator.valueToCode(block, 'ADD0', generator.ORDER_ADDITION) || '';
    return [item, generator.ORDER_ADDITION];
  }

  const parts = [];
  for (let i = 0; i < block.itemCount_; i += 1) {
    const item = generator.valueToCode(block, `ADD${i}`, generator.ORDER_NONE) || '';
    parts.push(`"${item.replace(/'|"/g, '')}"`);
  }

  return [parts.join(' + '), generator.ORDER_ADDITION];
};
